/**
 * Génère des initiales à partir d'un nom complet ou d'un prénom.
 * Ex: "Jean Denis" -> "JD", "Marc Dupont" -> "MD", "Marc" -> "MA"
 */
export function getInitials(
  firstName?: string | null,
  lastName?: string | null,
): string {
  const name =
    ((firstName?.[0] ?? "") + (lastName?.[0] ?? "")).toUpperCase() || "??";
  const parts = name.trim().split(/\s+/);

  if (parts.length >= 2) {
    // Cas "Jean Denis" ou "Marc Dupont" -> JD ou MD
    return (parts[0][0] + parts[1][0]).toUpperCase();
  }

  // Cas "Marc" -> MA (prend les deux premières lettres)
  if (parts[0].length >= 2) {
    return parts[0].substring(0, 2).toUpperCase();
  }

  return parts[0][0].toUpperCase();
}

/**
 * Génère des initiales à partir d'un nom d'entité (club, organisation, etc.).
 * Ex: "Pétanque Club de Lyon" -> "PC", "Association" -> "AS"
 */
export function getNameInitials(name: string): string {
  const words = name.trim().split(/\s+/);
  if (words.length >= 2) return (words[0][0] + words[1][0]).toUpperCase();
  if (words[0].length >= 2) return words[0].substring(0, 2).toUpperCase();
  return words[0][0].toUpperCase();
}

export function slugify(str: string): string {
  return str
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .trim();
}
